import { GQL_ID } from '@@types'

import { useFetchSingleBanner } from '@entities/Banners'

import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { BannerCarousel } from '@widgets/banner-carousel'

export default function BannerBlock ({ payload }: BlockProps) {
  const id = payload?.id as GQL_ID ?? null

  const { banner, loading, error } = useFetchSingleBanner({
    id
  })

  if (!banner || error || (!banner.bannerSlide?.url && !banner.bannerMobileSlide?.url)) {
    return null
  }

  return (
    <div className={styles.root__banner}>
      <BannerCarousel
        banners={[ banner ]}
        loading={loading}
      />
    </div>
  )
}
